import { STATUS, TEXTS } from '@/views/PesosCocidos/cookedWeightsConstants'
import { isWeighableGroup } from '@/utils/mealServingTotals'
import { formatMinimumWeight, formatWeight } from '@/views/PesosCocidos/weightDisplay'
import { describeGroupYield } from '@/views/PesosCocidos/weightYield'
import { fillTemplate } from '@/views/PesosCocidos/textTemplate'

const CLOCK_LOCALE = 'es-PE'
const CLOCK_FORMAT = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }

export function formatClockTime (isoMoment, timeZone) {
  if (!isoMoment) {
    return ''
  }
  return new Intl.DateTimeFormat(CLOCK_LOCALE, { ...CLOCK_FORMAT, timeZone }).format(new Date(isoMoment))
}

function measureOf (group) {
  if (group.status === STATUS.WEIGHED) {
    return { label: TEXTS.REGISTERED_WEIGHT_LABEL, grams: group.real_weight_grams, at: group.weighed_at }
  }
  if (group.status === STATUS.SHORT_WEIGHED) {
    return { label: TEXTS.LAST_ATTEMPT_WEIGHT_LABEL, grams: group.short_weight_grams, at: group.short_weighed_at }
  }
  return null
}

function describeYieldLine (group) {
  const yieldInfo = describeGroupYield(group)
  if (yieldInfo === null) {
    return null
  }
  return fillTemplate(TEXTS.YIELD_LINE, { real: yieldInfo.realPercent, minimum: yieldInfo.theoreticalPercent })
}

export function buildWeighingSummary (group) {
  const measure = measureOf(group)
  if (!isWeighableGroup(group) || measure === null) {
    return null
  }
  return {
    weightLabel: measure.label,
    weightText: formatWeight(measure.grams),
    weighedAt: measure.at || null,
    isBelowMinimum: group.status === STATUS.SHORT_WEIGHED,
    minimumText: formatMinimumWeight(group.theoretical_weight_grams),
    yieldText: describeYieldLine(group)
  }
}
